module.exports = __webpack_public_path__ + "img/doc-white-list.888a95d6.png";